import React from 'react';
import PropTypes from 'prop-types';
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import StyledContainer from '@zg-rentals/multibrand-ui/lib/StyledContainer';
import Row from '@zg-rentals/multibrand-ui/lib/Row';
import Col from '@zg-rentals/multibrand-ui/lib/Col';
import ContentBox2 from '@zg-rentals/multibrand-ui/lib/ContentBox2';
import SpacerRow from '@zg-rentals/multibrand-ui/lib/SpacerRow';
import CaretDownIcon from '@zg-rentals/multibrand-ui/lib/icons/CaretDown';
import CaretUpIcon from '@zg-rentals/multibrand-ui/lib/icons/CaretUp';
import Link from '@zg-rentals/multibrand-ui/lib/Link';
import { FaqModel } from '@common/types';
import ContactUsSection from '../ContactUsSection';

import './index.scss';

interface IFaqComponentProps {
  title?: string;
  faqs: FaqModel[];
  allOpen: boolean;
  boxed: boolean;
  contactUsLandlord: boolean;
  contactUsRenter: boolean;
  contentBoxElementType: any;
  linkToFaqs?: string;
}

class FaqComponent extends React.Component<IFaqComponentProps> {
  static defaultProps = {
    title: '',
    faqs: null,
    allOpen: false,
    boxed: false,
    contactUsLandlord: false,
    contactUsRenter: false,
    contentBoxElementType: ContentBox2,
  };

  static propTypes = {
    title: PropTypes.string,
    faqs: PropTypes.array,
    allOpen: PropTypes.bool,
    boxed: PropTypes.bool,
    contactUsLandlord: PropTypes.bool,
    contactUsRenter: PropTypes.bool,
    contentBoxElementType: PropTypes.elementType,
  };

  state = {
    openFaq: '-1',
  };

  toggleAnswer = (e) => {
    const clickedIndex = e.currentTarget.dataset.statekey;
    this.setState({
      openFaq: this.state.openFaq === clickedIndex.toString() ? '-1' : clickedIndex,
    });
  };

  renderOpenCloseIcon = (index) => {
    const Icon = this.state.openFaq === index.toString() ? CaretUpIcon : CaretDownIcon;
    return <Icon size="sm" />;
  };

  formatFaqs = (faqs) =>
    faqs.map((faq, index) => (
      <Row className="pan" key={faq.question}>
        <StyledContainer onClick={this.toggleAnswer} data-statekey={index}>
          <Col xs={11} sm={11} md={11} lg={11} className="cursorPointer">
            <Text type="body-small" emphasize>
              {faq.question}
            </Text>
          </Col>
          <Col xs={1} sm={1} md={1} lg={1} className="cursorPointer">
            {!this.props.allOpen && this.renderOpenCloseIcon(index)}
          </Col>
        </StyledContainer>
        {(this.props.allOpen || this.state.openFaq === index.toString()) && (
          <Col>
            <Text type="body-small" className="answer-body">
              {faq.answer}
              {this.props.linkToFaqs && (
                <Link target="_blank" to={this.props.linkToFaqs}>
                  {' '}
                  Learn more
                </Link>
              )}
            </Text>
          </Col>
        )}
        {(!this.props.contactUsLandlord && !this.props.contactUsRenter && faqs.length === index + 1) || (
          <hr className="FaqComponent-hr" />
        )}
      </Row>
    ));

  render() {
    const Wrapper = this.props.boxed ? this.props.contentBoxElementType : 'div';
    const showContactUsSection = this.props.contactUsLandlord || this.props.contactUsRenter;

    return (
      <Wrapper data-auto-test-id="faq-component">
        {this.props.title && (
          <Text type="body" emphasize>
            {this.props.title}
          </Text>
        )}
        <SpacerRow>
          {this.formatFaqs(this.props.faqs)}
          {showContactUsSection && <ContactUsSection isLandlord={this.props.contactUsLandlord} />}
        </SpacerRow>
      </Wrapper>
    );
  }
}

export default FaqComponent;
